var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 368.791,
    height: 78.145,
    viewBox: "0 0 368.791 78.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-stars"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1576",
    "data-name": "Rectangle 1576",
    width: 53,
    height: 78,
    transform: "translate(1355 7377)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6742",
    "data-name": "Group 6742",
    transform: "translate(-1061 -7376.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star",
    "data-name": "Icon ionic-ios-star",
    d: "M67.822,25.283H45.442l-6.8-20.3a2.464,2.464,0,0,0-4.625,0l-6.8,20.3H4.684A2.441,2.441,0,0,0,2.25,27.717a1.789,1.789,0,0,0,.046.411,2.339,2.339,0,0,0,1.019,1.719L21.709,42.809,14.649,63.333a2.441,2.441,0,0,0,.837,2.739,2.354,2.354,0,0,0,1.369.593,2.983,2.983,0,0,0,1.521-.548L36.329,53.322,54.281,66.117a2.851,2.851,0,0,0,1.521.548,2.186,2.186,0,0,0,1.354-.593,2.411,2.411,0,0,0,.837-2.739L50.934,42.809,69.176,29.725l.441-.38a2.552,2.552,0,0,0,.791-1.628A2.576,2.576,0,0,0,67.822,25.283Z",
    transform: "translate(1058.75 7373.48)",
    fill: "#778ff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star-2",
    "data-name": "Icon ionic-ios-star",
    d: "M67.822,25.283H45.442l-6.8-20.3a2.464,2.464,0,0,0-4.625,0l-6.8,20.3H4.684A2.441,2.441,0,0,0,2.25,27.717a1.789,1.789,0,0,0,.046.411,2.339,2.339,0,0,0,1.019,1.719L21.709,42.809,14.649,63.333a2.441,2.441,0,0,0,.837,2.739,2.354,2.354,0,0,0,1.369.593,2.983,2.983,0,0,0,1.521-.548L36.329,53.322,54.281,66.117a2.851,2.851,0,0,0,1.521.548,2.186,2.186,0,0,0,1.354-.593,2.411,2.411,0,0,0,.837-2.739L50.934,42.809,69.176,29.725l.441-.38a2.552,2.552,0,0,0,.791-1.628A2.576,2.576,0,0,0,67.822,25.283Z",
    transform: "translate(1133.908 7373.48)",
    fill: "#778ff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star-3",
    "data-name": "Icon ionic-ios-star",
    d: "M67.822,25.283H45.442l-6.8-20.3a2.464,2.464,0,0,0-4.625,0l-6.8,20.3H4.684A2.441,2.441,0,0,0,2.25,27.717a1.789,1.789,0,0,0,.046.411,2.339,2.339,0,0,0,1.019,1.719L21.709,42.809,14.649,63.333a2.441,2.441,0,0,0,.837,2.739,2.354,2.354,0,0,0,1.369.593,2.983,2.983,0,0,0,1.521-.548L36.329,53.322,54.281,66.117a2.851,2.851,0,0,0,1.521.548,2.186,2.186,0,0,0,1.354-.593,2.411,2.411,0,0,0,.837-2.739L50.934,42.809,69.176,29.725l.441-.38a2.552,2.552,0,0,0,.791-1.628A2.576,2.576,0,0,0,67.822,25.283Z",
    transform: "translate(1209.066 7373.48)",
    fill: "#778ff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star-4",
    "data-name": "Icon ionic-ios-star",
    d: "M67.822,25.283H45.442l-6.8-20.3a2.464,2.464,0,0,0-4.625,0l-6.8,20.3H4.684A2.441,2.441,0,0,0,2.25,27.717a1.789,1.789,0,0,0,.046.411,2.339,2.339,0,0,0,1.019,1.719L21.709,42.809,14.649,63.333a2.441,2.441,0,0,0,.837,2.739,2.354,2.354,0,0,0,1.369.593,2.983,2.983,0,0,0,1.521-.548L36.329,53.322,54.281,66.117a2.851,2.851,0,0,0,1.521.548,2.186,2.186,0,0,0,1.354-.593,2.411,2.411,0,0,0,.837-2.739L50.934,42.809,69.176,29.725l.441-.38a2.552,2.552,0,0,0,.791-1.628A2.576,2.576,0,0,0,67.822,25.283Z",
    transform: "translate(1284.225 7373.48)",
    fill: "#778ff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star-5",
    "data-name": "Icon ionic-ios-star",
    d: "M67.822,25.283H45.442l-6.8-20.3a2.464,2.464,0,0,0-4.625,0l-6.8,20.3H4.684A2.441,2.441,0,0,0,2.25,27.717a1.789,1.789,0,0,0,.046.411,2.339,2.339,0,0,0,1.019,1.719L21.709,42.809,14.649,63.333a2.441,2.441,0,0,0,.837,2.739,2.354,2.354,0,0,0,1.369.593,2.983,2.983,0,0,0,1.521-.548L36.329,53.322,54.281,66.117a2.851,2.851,0,0,0,1.521.548,2.186,2.186,0,0,0,1.354-.593,2.411,2.411,0,0,0,.837-2.739L50.934,42.809,69.176,29.725l.441-.38a2.552,2.552,0,0,0,.791-1.628A2.576,2.576,0,0,0,67.822,25.283Z",
    transform: "translate(1359.383 7373.48)",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_76",
    "data-name": "Mask Group 76",
    clipPath: "url(#clip-path-stars)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-star-6",
    "data-name": "Icon ionic-ios-star",
    d: "M67.822,25.283H45.442l-6.8-20.3a2.464,2.464,0,0,0-4.625,0l-6.8,20.3H4.684A2.441,2.441,0,0,0,2.25,27.717a1.789,1.789,0,0,0,.046.411,2.339,2.339,0,0,0,1.019,1.719L21.709,42.809,14.649,63.333a2.441,2.441,0,0,0,.837,2.739,2.354,2.354,0,0,0,1.369.593,2.983,2.983,0,0,0,1.521-.548L36.329,53.322,54.281,66.117a2.851,2.851,0,0,0,1.521.548,2.186,2.186,0,0,0,1.354-.593,2.411,2.411,0,0,0,.837-2.739L50.934,42.809,69.176,29.725l.441-.38a2.552,2.552,0,0,0,.791-1.628A2.576,2.576,0,0,0,67.822,25.283Z",
    transform: "translate(1359.383 7373.48)",
    fill: "#778ff4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStars);
export default __webpack_public_path__ + "static/media/icon-stars.707f06fdb50e36146ae9df42e503d927.svg";
export { ForwardRef as ReactComponent };